<template>
  <!-- 姓名 -->
  <yxtbiz-user-name v-if="code === dictionaryKeys.userName" :name="name" />
  <!-- 部门 -->
  <yxtbiz-dept-name v-else-if="code === dictionaryKeys.deptName" :name="name" />
  <!-- 其他 -->
  <span v-else>{{ name }}</span>
</template>
<script>
import { dictionaryKeys } from '../config';

export default {
  props: {
    // 类型
    code: {
      type: String,
      default: ''
    },
    // 名称
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dictionaryKeys
    };
  }
};
</script>
